import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'
import dayjs from 'dayjs'

class GroupTermingType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._id = init.id
    this._created_at = init.created_at
    this._updated_at = init.updated_at
    this._client_name = init.client_name
    this._engineering_status = init.engineering_status
    this._jira_ticket_link = init.jira_ticket_link
    this._requestor = init.requestor
    this._run_out_date = init.run_out_date
    this._special_instruction = init.special_instruction
    this._term_date = init.term_date
    this._termination_reason = init.termination_reason
  }

  static shape = {
    id: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    client_name: PropTypes.string,
    engineering_status: PropTypes.string,
    jira_ticket_link: PropTypes.string,
    requestor: PropTypes.string,
    run_out_date: PropTypes.string,
    special_instruction: PropTypes.string,
    term_date: PropTypes.string,
    termination_reason: PropTypes.string
  }

  get id() {
    return this._id
  }

  get created_at() {
    return this._created_at
  }

  get updated_at() {
    return this._updated_at
  }

  get client_name() {
    return this._client_name
  }

  get engineering_status() {
    return this._engineering_status
  }

  get jira_ticket_link() {
    return this._jira_ticket_link
  }

  get requestor() {
    return this._requestor
  }

  get run_out_date() {
    return dayjs(new Date(this._run_out_date).toISOString())
  }

  get special_instruction() {
    return this._special_instruction
  }

  get term_date() {
    return dayjs(new Date(this._term_date).toISOString())
  }

  get termination_reason() {
    return this._termination_reason
  }
}

export default GroupTermingType
